import { ScopeOfPracticeEnum } from '@umss/shared/utils';

export interface CreateFacilityBillableRateDto {
  scopeOfPractice: ScopeOfPracticeEnum; // Required
  hourlyRate: number; // Required, range 0.01-1000.00, decimal
  urgentHourlyRate?: number | null; // Optional, range 0.01-1000.00, decimal
  scheduledRates?: CreateFacilityScheduledBillableRateDto[]; // Optional
  differentialRate?: number; // Optional, range 0.01-1000.00, decimal
}

export interface CreateFacilityScheduledBillableRateDto {
  rate: number; // Required, range 0.01-1000.00, decimal
  effectiveFrom: string; // Required, ISO 8601 format (e.g., "2025-12-25T00:00:00Z")
  effectiveTo: string; // Required, ISO 8601 format (e.g., "2025-12-25T23:59:59Z")
}
